var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 7.0638H19.2292C20.2074 7.0638 21 7.85643 21 8.83464V16.6263C21 17.6045 20.2074 18.3971 19.2292 18.3971H10.0554V17.6888H19.2292C19.815 17.6888 20.2917 17.2121 20.2917 16.6263V8.83464C20.2917 8.24884 19.815 7.77214 19.2292 7.77214H7.1875C6.27375 7.77214 5.411 7.37618 4.81175 6.70893C4.74446 6.93347 4.70833 7.17147 4.70833 7.41797V13.0042H4V7.41797C4 5.65776 5.42729 4.23047 7.1875 4.23047H20.6458C20.8413 4.23047 21 4.38914 21 4.58464C21 4.78014 20.8413 4.9388 20.6458 4.9388H7.1875C6.34671 4.9388 5.60225 5.35955 5.15317 6.00201C5.61429 6.66218 6.37575 7.0638 7.1875 7.0638ZM18.1667 13.4388C18.5577 13.4388 18.875 13.1215 18.875 12.7305C18.875 12.3395 18.5577 12.0221 18.1667 12.0221C17.7757 12.0221 17.4583 12.3395 17.4583 12.7305C17.4583 13.1215 17.7757 13.4388 18.1667 13.4388Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0532 16.4725H7.49716V19.0645H6.47716V16.4725H3.93316V15.5485H6.47716V12.9445H7.49716V15.5485H10.0532V16.4725Z",
    fill: "#5260FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopup);
export default __webpack_public_path__ + "static/media/Topup.a51056e73ad3281474d97aad937aca02.svg";
export { ForwardRef as ReactComponent };